export function scrollButton() {
  const buttonsScroll = $(".button-scroll");

  for (const button of buttonsScroll) {
    button.addEventListener( "click", function (e) {
      e.preventDefault();
      const classElementToScroll = this.getAttribute("data-scroll");
      if (classElementToScroll === "header") {
        $("html, body").animate({
          scrollTop: 0
        }, 1000);
      } else {
        $("html, body").animate({
          scrollTop: $(classElementToScroll).offset().top
        }, 1000);
      }
    });
  }
}



// WEBPACK FOOTER //
// ./assets/js/modules/scroll-button.js